import { FixedAssetService } from "./../../../services/catalogs/FixedAssetService";
import { CreateFixedAssetDto } from "../../../dtos/catalogs/fixedasset/CreateFixedAssetDto";
import React from "react";
import { FixedAssetDetail } from "../../../components/Pages/Catalogs/FixedAsset/FixedAssetDetail";

import { CatalogService } from "../../../services/catalogs/CatalogService";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupFixedAsset } from "../../../components/Shared/NewForms/NFLookupFixedAsset";
import FixedAssetList from "../../../components/Pages/Catalogs/FixedAsset/FixedAssetList";

export const FixedAsset: IAppEntity = {
  entityType: "catalog",
  title: "Fixed Asset",
  pluralTitle: "Fixed Asset",
  apiUrl: "FixedAssets",
  apiEnum: ReferenceTypes.CatalogFixedAsset,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(FixedAssetDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(FixedAssetList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupFixedAsset, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new FixedAssetService(this.apiUrl);
  },
  getEmptyModel(): CreateFixedAssetDto {
    return {
      name: "",
    };
  },
};
